import { Dispatch } from 'redux';
import { PaginatedResponse } from '@synergy/api';
import { isRecentCancellation } from '@synergy/utils';

import { Api } from '../../../api';
import { AppState } from '../../../store/models/app-state';
import { PurchaseOrder } from '../../../common/models/purchase-order';

export const RECEIVE_PURCHASE_ORDERS = 'RECEIVE_PURCHASE_ORDERS';
export const REQUEST_PURCHASE_ORDERS = 'REQUEST_PURCHASE_ORDERS';
export const RESET_PURCHASE_ORDERS = 'RESET_PURCHASE_ORDERS';

const requestPurchaseOrdersData = () => {
    return { type: REQUEST_PURCHASE_ORDERS };
};

const receivePurchaseOrdersData = (purchaseOrders: PaginatedResponse<PurchaseOrder>) => {
    return {
        type: RECEIVE_PURCHASE_ORDERS,
        purchaseOrders,
    };
};

export const resetPurchaseOrders = () => {
    return { type: RESET_PURCHASE_ORDERS };
};

export const fetchPurchaseOrders = (searchParams?: URLSearchParams) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch(requestPurchaseOrdersData());

        const response = await api.purchaseOrders.cget(searchParams);
        if (response.success) {
            dispatch(receivePurchaseOrdersData(response.result));
        }
    };
};

/**
 * The cancellations of the last days, newest first, for the notice above the
 * list: asked for on their own, so one on page three still warns (#2267).
 */
export const fetchRecentCancellations = () => {
    return async (_dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }): Promise<PurchaseOrder[]> => {
        const response = await api.purchaseOrders.cget(
            new URLSearchParams({ statuses: 'STATUS_CANCELED', sort: 'updatedAt', order: 'desc', limit: '20' })
        );

        return response.success
            ? response.result.items.filter((order: PurchaseOrder) => isRecentCancellation(order))
            : [];
    };
};
